import { render, staticRenderFns } from "./VCardKachel.vue?vue&type=template&id=84446098&scoped=true"
import script from "./VCardKachel.vue?vue&type=script&lang=ts"
export * from "./VCardKachel.vue?vue&type=script&lang=ts"
import style0 from "./VCardKachel.vue?vue&type=style&index=0&id=84446098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84446098",
  null
  
)

export default component.exports